import { render, staticRenderFns } from "./bulma_pictures.vue?vue&type=template&id=01f49e98"
import script from "./bulma_pictures.vue?vue&type=script&lang=js"
export * from "./bulma_pictures.vue?vue&type=script&lang=js"
import style0 from "./bulma_pictures.vue?vue&type=style&index=0&id=01f49e98&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports